module.exports = "/_next/static/images/IdentityResolution-d6684d843b20245f96a5672e03ce52d2.png";